// extracted by mini-css-extract-plugin
var _1 = "kUmEn";
var _2 = "qAIrY";
var _3 = "T0y6v";
var _4 = "rZJNS";
var _5 = "Z7Pxw";
export { _1 as "contact", _2 as "message", _3 as "not-found", _4 as "not-found-icon", _5 as "title" }
